
<div class="position-relative" id="{{'item-' + badMoodPass.id}}">

    @if(careCount > 0 || threadsCount > 0){
    <div class="streaks-card-wrapper bad-pass card" id="{{badMoodPass.id}}">
            <article class="streaks-card">
                <div class="streaks-card-content">
                    <a href="https://help.teammood.com/en/articles/6701896-about-bad-mood-streaks" target="_blank" class="streak-help-link"><i class="fa-solid fa-circle-question"></i></a>
                    <h4>{{ 'bad-mood-pass.title' | translate}}</h4>
                    <div class="bad-pass-text mb-3">
                        @if(careCount === 1){
                        <p>
                            <i class="fa-solid fa-hand-holding-heart pe-1"></i> {{careCount}} {{ 'bad-mood-pass.description-care' | translate}}
                        </p>
                        } @else if(careCount > 1){
                            <p>
                                <i class="fa-solid fa-hand-holding-heart pe-1"></i> {{careCount}} {{ 'bad-mood-pass.description-care-multiple' | translate}}
                            </p>
                        } @else if(threadsCount === 1 && careCount === 0){
                            <p>
                                {{ 'bad-mood-pass.description-discuss' | translate}}
                            </p>
                        } @else if(threadsCount > 1 && careCount === 0){
                            <p>
                                {{ 'bad-mood-pass.description-discuss-multiple' | translate}}
                            </p>
                        } @else if(careCount === 1 && threadsCount > 0){
                            <p>
                                {{ 'bad-mood-pass.description-care-and-discuss' | translate}}
                            </p>
                        } @else if(careCount > 1 && threadsCount > 0){
                            <p>
                                {{ 'bad-mood-pass.description-care-and-discuss-multiple' | translate}}
                            </p>
                        }
                    </div>
                </div>
                @if(threadsCount > 0){
                <div class="media-bottom card-bottom streaks-card-actions">
                    <tm-reactions [timelineItem]="badMoodPass" [reactionType]="'none'" [discussLabel]="'bad-mood-streak.reply'"
                               (onReacted)="onReacted($event)"
                               (onToggleThreads)="toggleThreads()"
                               (onDiscuss)="discuss()"></tm-reactions>

                    @if(showThreads){
                    <tm-threads [timelineItem]="badMoodPass" #threadsComponent
                                [userInfos]="userInfos"
                                (onThreadsUpdated)="onThreadsUpdated($event)"></tm-threads>
                    }
                </div>
                }
            </article>
        </div>

    <!-- @if(badMoodPass.educationalCard){
    <div class="position-absolute mb-md-3 hide-for-mobile top-0 start-100 ms-4"
         [class]="{'hide-for-large-screen': !isOdd, 'hide-oft': isOdd }">
        <tm-educational-card
                [educCardId]="badMoodPass.educationalCard"
                [threadComponent]="getThreadsComponent">
        </tm-educational-card>
    </div>
    } -->
    @if(badMoodPass.managerPanel){
        <div class="manager-panel-wrapper"
             [class]="isOdd ? 'odd-timeline-item': 'even-timeline-item'">
            <tm-manager-panel [managerPanel]="badMoodPass.managerPanel"
                              [reviewed]="badMoodPass.reviewed.length !== 0"></tm-manager-panel>
        </div>
    }
    }
</div>